import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-billing-oversight-dashboard",
  templateUrl: "./billing-oversight-dashboard.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingOversightDashboardComponent {
filters: string[] = ["Projects"];
dashboardType = LookerMemberManagementDashboardType.Billing_Oversight_Dashboard;
hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORGANIZATION_ID, HideFilters.CUSTOMER_NAME2];
}
